import React, {useContext} from 'react';
import {useDispatch} from 'react-redux';
import {Button} from '~library/atoms/Button';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import './DoneButton.sass';

export const DoneButton = () => {
  const {canvas} = useContext(EventCreateContext);
  const dispatch = useDispatch();

  const discardSelection = () => {
    canvas?.discardActiveObject()?.requestRenderAll();

    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {
        activeCardEditor: 'intro',
      },
    });
  };

  return (
    <Button
      variant="secondary"
      size="large"
      fullWidth
      className="uyo_control__button__done"
      onClick={discardSelection}
      data-qa-id="done-btn"
    >
      Done
    </Button>
  );
};
